import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { addTeamMember, releaseTeamMember } from "../../Redux/Config/Action";
import { projectAccessListByProjectId } from "../../Redux/Config/Action";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import NewDataTable from "../DataTable/NewDataTable";
import { FaEdit } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { empList } from "../../Redux/DailyUpdateApproval/Action";
import Select from "react-select";
import { MdPersonRemove } from "react-icons/md";

const ProjectAccess = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const rowData = location.state?.row;
    const token = localStorage.getItem("token");
    const { projectAccessList } = useSelector((store) => store.config);
    const { emplists } = useSelector((store) => store.dailyUpdateApprover);

    const [show, setShow] = useState(false);
    const [projectMasterId, setProjectMasterId] = useState("");
    const [projectTeamMembers, setProjectTeamMembers] = useState([]);


    const [projectData, setProjectData] = useState({
        projectMasterId: projectMasterId || "",
        type: "USER",
        loginIdList: [],
    });


    useEffect(() => {
        setProjectMasterId(rowData?.projectMasterId || "");
    }, [rowData]);

    useEffect(() => {
        if (projectMasterId) {
            dispatch(projectAccessListByProjectId(projectMasterId, token));
        }
        dispatch(empList(token, "EMP"));
    }, [dispatch, projectMasterId, token]);

    useEffect(() => {
        setProjectTeamMembers(
            projectAccessList?.map(item => item.loginId) || []
        );
    }, [projectAccessList]);

    const empOptions = emplists
        .filter(emp => !projectTeamMembers.includes(emp.loginId) && emp.firstName)
        .map(p => ({
            value: p.loginId,
            label: `${p?.firstName || ""} ${p?.lastName || ""}`.trim(),
        }));

    const typeOptions = [
        { value: "OWNER", label: "OWNER" },
        { value: "USER", label: "USER" }
    ];

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };

    const handleReleaseClick = async (projectData) => {

        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(releaseTeamMember(projectData.projectAccessId, projectData.loginId, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        dispatch(projectAccessListByProjectId(projectMasterId, token));
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Something went wrong. Please try again later.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }


    }

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Employee Name",
            selector: (row) => row?.empName || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Type",
            selector: (row) => row?.type || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            align: "center",
            cell: (row) => (
                <Tooltip text="Release From Project">
                    <MdPersonRemove
                        className="text-danger cursor-pointer" size={22}
                        onClick={() => handleReleaseClick(row)}
                    />
                </Tooltip>

            ),

        },
    ];


    const clearInputFields = () => {
        setProjectData((prev) => ({
            ...prev,
            type: 'USER',
            loginIdList: [],
        }));
    };

    const handleClose = () => {
        clearInputFields();
        setShow(false);
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setProjectData((prevData) => {
            let updatedData = {
                ...prevData,
                [id]: value,
            };
            return updatedData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (projectData.loginIdList.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "Warning",
                text: "Please select all the required fields.",
                timer: 2000,
            });
            return;
        }
        const payload = {
            ...projectData,
            projectMasterId: projectMasterId,
        }

        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(addTeamMember(payload, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        setShow(false);
                        clearInputFields();
                        dispatch(projectAccessListByProjectId(projectMasterId, token));
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Something went wrong. Please try again later.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }
    };


    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="card3">
                        <div className="text-center">
                            <h4>
                                <span className="fw-semibold">Project Team:</span>{" "}
                                <span className="text-primary">{rowData?.projectName}</span>
                            </h4>
                        </div>
                        <div className="card-body">
                            <NewDataTable
                                columns={columns}
                                data={projectAccessList || []}
                                // tableName="PROJECT TEAM"
                                totalRecord={projectAccessList?.length ?? 0}
                            />
                            <div className="text-center mt-3">
                                <button
                                    type="button"
                                    className="btn btn-primary fw-bold  me-2"
                                    onClick={() => setShow(true)}
                                >
                                    ADD NEW MEMBER
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary fw-bold"
                                    onClick={() => window.history.back()}
                                >
                                    BACK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Team Member: {rowData?.projectName}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="projectCode">
                                                <b>Type</b><span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                options={typeOptions}
                                                value={typeOptions.find(opt => opt.value === projectData.type) || null}
                                                onChange={(selectedOption) =>
                                                    setProjectData(prev => ({
                                                        ...prev,
                                                        type: selectedOption?.value || "",
                                                    }))
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="leaveCode" className="form-label">
                                            Employee Name <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            options={empOptions}
                                            isMulti
                                            value={empOptions.filter(opt => projectData.loginIdList.includes(opt.value))}
                                            onChange={(selectedOptions) =>
                                                setProjectData(prev => ({
                                                    ...prev,
                                                    loginIdList: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                                                }))
                                            }
                                            closeMenuOnSelect={false}
                                            required
                                        />
                                    </div>

                                </div>
                                <div className="text-center">
                                    <button type="submit" className="btn btn-success mt-3">
                                        SUBMIT
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default ProjectAccess;